export const Common = {
  Choose: 'Vyberte',
  No: 'Nie',
  Yes: 'Áno',
};
